// Client-side active-workspace memory. The switcher writes here; the fetch
// client reads and forwards the id as `X-Workspace-Id`. Middleware then
// resolves membership server-side.

const KEY = 'rlpscout:active_workspace_id';

export function getActiveWorkspaceId(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setActiveWorkspaceId(id: string | null): void {
  try {
    if (id) localStorage.setItem(KEY, id);
    else localStorage.removeItem(KEY);
  } catch {
    // Storage is a non-essential UX convenience; swallow in private-mode browsers.
  }
}
